module.exports = __webpack_public_path__ + "static/media/cartoes_visa.984a68c6.svg";